import { getRouteApi } from '@tanstack/react-router';

export const inventoryInvoicesRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/invoices/invoices-list-layout/',
);

export const invoiceDetailsRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/invoices/$invoiceId',
);

export const nonInventoryInvoicesRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/non-inventory-invoices/non-inventory-list-layout/',
);

export const grirListRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/grir/grir-list-layout/',
);

export const grirDetailRouteApi = getRouteApi('/auth/merchant/menuLayout/finance/grir/$caseId');

export const clawbackListRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/clawback/clawback-list-layout/',
);

export const clawbackDetailRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/clawback/$requestId',
);

export const tasksListLayoutRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/tasks/tasks-list-layout',
);

export const tasksListRouteApi = getRouteApi(
  '/auth/merchant/menuLayout/finance/tasks/tasks-list-layout/$taskType',
);
